import Icon from 'veui/components/Icon'
import { IconUserLabel } from 'dls-icons-vue'

Icon.register('user-label', IconUserLabel)
